export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/common-area/index/resources/computed.js